import {match, Pattern} from 'ts-pattern';

import {gt} from 'ramda';
import {toNumber} from 'ramda-adjunct';

import {isNilOrZero} from 'shared/web';

import {FeatureStateFlagSeverity} from '../../../components/FeatureStateFlag/FeatureStateFlag';
import i18n from '../../../i18n/i18n';
import {ValueWithUnit} from '../../../types/ValueWithUnit';
import {getValueWithUnit} from '../../../utils/getValueWithUnit';
import {isB2cCarAuditWorkspace} from '../../../utils/isB2cCarAuditWorkspace';

function b2cCarAuditGetSeverityAndTextForPaintThickness(row: ValueWithUnit | null) {
  const text =
    getValueWithUnit({
      auditValue: row,
      defaultUnitTranslate: i18n.t('metricMicroMetre'),
    }) ?? null;

  const value = toNumber(row?.value);

  const severity = match<typeof value, FeatureStateFlagSeverity>(value)
    .with(Pattern.number.between(50, 150), () => 'ready')
    .with(Pattern.number.between(150, 180), () => 'warning')
    .with(Pattern.number.between(180, 250), () => 'attention')
    .with(Pattern.number.between(250, 400), () => 'damaged')
    .with(Pattern.number.gte(400), () => 'excessive')
    .otherwise(() => 'neutral');

  return {text, severity};
}

export const getSeverityAndTextForPaintThickness = (
  row: ValueWithUnit | null,
  warningTreshold: number
) => {
  if (isB2cCarAuditWorkspace()) {
    return b2cCarAuditGetSeverityAndTextForPaintThickness(row);
  }

  const text =
    getValueWithUnit({
      auditValue: row,
      defaultUnitTranslate: i18n.t('metricMicroMetre'),
    }) ?? null;

  const severityOverride: FeatureStateFlagSeverity | false = !text && 'neutral';

  const resultSeverity: FeatureStateFlagSeverity =
    severityOverride ||
    (gt(toNumber(row?.value) ?? 0, warningTreshold) || isNilOrZero(toNumber(row?.value))
      ? 'damaged'
      : 'ready');

  return {text, severity: resultSeverity};
};
